import React from 'react';

const LoadingSpinnerInfo = () => (
  <div>
    <i className="fa fa-spinner fa-spin text-white" /> Obtiendo información
  </div>
);

export default LoadingSpinnerInfo;